import { zefDialogOpen, zefDialogClose } from '@zerops/zef/dialog';
import { FEATURE_NAME } from './victoria-logs-overlay.constant';
import { VictoriaLogsOverlayMeta } from './victoria-logs-overlay.model';

export const victoriaLogsOverlayOpen = (meta: VictoriaLogsOverlayMeta) =>
  zefDialogOpen({ key: FEATURE_NAME, meta });

export const victoriaLogsOverlayClose = () =>
  zefDialogClose({ key: FEATURE_NAME });
